// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Image_fullWidth__Z4u3m","picture":"Image_picture__qmT5K"};